import {
  DOC_FLOW_PHASE_TITLE_KEYS,
  DOC_FLOW_STATUSES,
  DocFlowTableCellName,
} from '../../../constants/docFlow'
import { formatNumberWithSeparators } from '../../../utils/number'
import { EntityArchivedIcon } from '../../Entity'
import { TableStatusCell, TableTextCell, TableTitleCell } from '../../Table'

import * as styles from './DocFlowSelectModalTableRow.module.css'

import DocFlowIcon from '../../../icons/doc-splitting.svg'

export function renderCell({ item, name, t, ...restProps }) {
  const { archived, id, [name]: value } = item

  switch (name) {
    case DocFlowTableCellName.Name:
      return (
        <TableTitleCell
          {...restProps}
          TextArchivedIcon={archived ? EntityArchivedIcon : null}
          avatarProps={{ Icon: DocFlowIcon }}
          id={id}
          textArchivedIconProps={{
            containerClassName: styles.archivedIconContainer,
          }}
          value={value}
        />
      )

    case DocFlowTableCellName.DocumentsCount:
      return <TableTextCell {...restProps} value={value} />

    case DocFlowTableCellName.EpostSpentCredits:
      return (
        <TableTextCell
          {...restProps}
          value={value ? formatNumberWithSeparators(value) : value}
        />
      )

    case DocFlowTableCellName.Phase:
      return (
        <TableTextCell
          {...restProps}
          value={t(DOC_FLOW_PHASE_TITLE_KEYS[value])}
        />
      )

    case DocFlowTableCellName.Status:
      return (
        <TableStatusCell
          {...restProps}
          statuses={DOC_FLOW_STATUSES}
          value={value}
        />
      )

    default:
      return null
  }
}
